export default __webpack_public_path__ + "_static_/media/nothing-suggested-illustration.72bb39d5.svg";